/* Tracker client data model
 *
 * Angular Module: trackerbase-app.models.tracker
 * Injected Factory: Tracker
 */

import makePropsEnumerable from "../utility/MakePropsEnumerable";

class Tracker {
    constructor(
        userId,
        firstName,
        lastName,
        isActive,
        trackerMediaId,
        primaryArea
    )
    {
        if (userId.match(Tracker.GuidRegEx)) {
            this.trackerId = userId;
        }
        else {
            throw new TypeError("Invalid User Id Value.");
        }

        this.firstName = firstName;
        this.lastName = lastName;
        this.isActive = isActive;
        this.mediaId = trackerMediaId;
        this.primaryArea = primaryArea;
    }

    valueOf() {
        return this.trackerId;
    }
    
    toString() {
        return `${this.lastName}, ${this.firstName}`;
    }
    
    get displayName() {
        return `${this.firstName} ${this.lastName}`;
    }

    get sortName() {
        return `${this.lastName}, ${this.firstName}`;
    }
    
    static get GuidRegEx() { return /^[A-F0-9]{8}-(?:[A-F0-9]{4}-){3}[A-F0-9]{12}$/i; }

    static CopyTracker(otherTracker) {
        return new Tracker(
            otherTracker.trackerId,
            otherTracker.firstName,
            otherTracker.lastName,
            otherTracker.isActive,
            otherTracker.mediaId,
            otherTracker.primaryArea
        );
    }
    
    static FromServerTracker(serverTracker) {

        if (serverTracker == null)
        {
            return null;
        }

        let sTracker = new Tracker(
            serverTracker.TrackerBaseUserId,
            serverTracker.FirstName,
            serverTracker.LastName,
            serverTracker.IsActive,
            serverTracker.TrackerMediaId,
            serverTracker.PrimaryArea
        );

        return sTracker;
    }
}

//Define properties as enumerable for kendo.
makePropsEnumerable(Tracker.prototype, [ "displayName", "sortName" ]);

export default Tracker;




//////////////////
// WEBPACK FOOTER
// ./src/models/Tracker.js
// module id = AHsi
// module chunks = 1